import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { ClavaContext } from "../../../../config/contexts";
import { translate, TranslatorKeys } from "../../../../config/translator";
import { getStoreDownloadUrl } from "../../../../config/utils";

type ProBannerProps = {
  featureList: TranslatorKeys[];
};

const ProBanner: React.FC<ProBannerProps> = ({ featureList }) => {
  const { l } = useContext(ClavaContext);

  return (
    <div className="absolute inset-0 flex flex-col justify-between bg-bg-secondary/80 dark:bg-bg-secondary-dark/80 rounded-xl z-10 px-4 pt-4 pb-3 pointer-events-none">
      <div className="text-left pointer-events-auto">
        <h3 className="text-base font-semibold text-font dark:text-font-dark mb-1">
          {translate("tryClavaPro", l)}
        </h3>
        <ul className="text-sm text-font-600 dark:text-font-600-dark space-y-0.5">
          {featureList.map((feature) => (
            <li key={feature} className="flex items-center gap-2">
              <FontAwesomeIcon
                icon={faCircleCheck}
                className="text-pro-700 dark:text-pro-700-dark"
                size="sm"
              />
              <span>{translate(feature, l)}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="pointer-events-auto mt-3 mb-1">
        <a
          href={getStoreDownloadUrl()}
          className="w-full rounded-full py-2 px-4 flex flex-row items-center justify-center border-0 text-font-dark text-sm font-semibold relative overflow-hidden hover:opacity-90 active:opacity-95 transition-opacity"
          style={{
            background: `linear-gradient(to bottom, #FFD700, #B8860B)`,
          }}
        >
          <span className="relative z-10">{translate("downloadNow", l)}</span>
        </a>
      </div>
    </div>
  );
};

export default ProBanner;

